import React, { useEffect } from "react";
import Layout from "../../components/Layout";
import Hero from "../../components/Hero";
import heroImage from "../../assets/usedcar-new-desk.jpeg";
import heroImageMob from "../../assets/usedcar-new-mob.jpeg";
import { Container, Grid, Alert, Button } from "@mui/material";
import CarCard from "../../components/Cards/CarCard";
import CarFilter from "../../components/CarFilter/CarFilter";
import { FormattedMessage } from "react-intl";
import { useGetAllCarsQuery } from "../../app/api/Apis";
import { useDispatch, useSelector } from "react-redux";
import CarListSkeleton from "../../components/Loaders/CarListSkeleton";
import NoDataPlaceholder from "../../components/NoDataPlaceholder";
import { refetchToken, showLoader } from "../../utils/globalSlice";
import SeoContent from "../Seo/SeoContent";
import { useLocation } from "react-router-dom";

const HomePage = () => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const featuredBrand = params.get("brand");
  const featuredModel = params.get("model");

  const dispatch = useDispatch(); // define use dispatch hook

  //get token from redux store
  const token = useSelector((state) => state?.global?.token);

  //get token error state from store if token api fails
  const tokenError = useSelector((state) => state.global.apiError);

  //get selected brand data from store (selection made from carFilter component)
  const brand = useSelector((state) => state.carFilter.selectedBrand);

  // get selected model data from store (selection made from carFilter component)
  const model = useSelector((state) => state.carFilter.selectedModel);

  //get selected year data from store (selection made from carFilter component)
  const year = useSelector((state) => state.carFilter.selectedYear);

  const isMob = useSelector((state) => state.global.isMobile);

  //define payload for car list api (limit is gives as 100 assuming the maximum available cars won't go beyond 100)
  //if more cars then to implement pagination/load more options
  const payload = {
    payloadData: {
      brandId: brand === "" ? null : brand,
      modelId: model === "" ? null : model,
      yearOfManufacture: year === "" ? null : year,
      bodyTypeId: null,
      carStatusId: 1,
    },
    limit: 100,
    offset: 0,
  };

  //rtk query to get all cars, refetches if any args changed and skipped if token not available
  const {
    isLoading: carsLoading,
    isError: carsError,
    data: carsList,
    refetch,
  } = useGetAllCarsQuery(payload, {
    refetchOnMountOrArgChange: true,
    // skip: !token,
  });

  // useeffect hook to show loader if query is in loading state
  useEffect(() => {
    if (carsLoading) {
      dispatch(showLoader(true));

      return () => {
        dispatch(showLoader(false));
      };
    }
  }, [carsLoading]);

  //handl retry function defenition
  //if token error, then retries the token query defined in app component with the store value tokenError
  //otherwise refetches the car listing api
  const handleRetry = () => {
    if (tokenError !== "") {
      dispatch(refetchToken());
    } else {
      refetch();
    }
  };
  return (
    <Layout>
      <SeoContent
        title="Fazaa Used Cars"
        image={`${window?.location?.origin}${heroImageMob}`}
        description="Explore a wide selection of quality used cars at unbeatable prices. Browse through our extensive inventory, find your perfect match, and enjoy a hassle-free buying experience with trusted dealers. Start your journey today!"
        url="https://usedcars.fazaa.ae/"
        keywords="Used cars for sale, Affordable used cars, Certified used cars, Used car deals, Buy used cars online, Used cars near me, Best used cars, Used cars with warranty"
      />
      <Hero
        image={isMob ? heroImageMob : heroImage}
        text={<FormattedMessage id="app.heroText" />}
        scrollPosition="650"
      />
      <Container maxWidth="lg" sx={{ my: "2rem", flexGrow: 1, p: 2 }}>
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <CarFilter
              presetBrand={featuredBrand}
              presetModel={featuredModel}
            />
          </Grid>
          {(carsError || tokenError) && (
            <Grid item xs={12}>
              <Alert
                severity="error"
                action={
                  <Button
                    variant="outlined"
                    size="small"
                    color="secondary"
                    onClick={handleRetry}
                  >
                    Retry
                  </Button>
                }
              >
                Something went wrong white loading the cars!!
              </Alert>
            </Grid>
          )}
          {carsLoading ? (
            [...Array(10).keys()].map((item, index) => (
              <CarListSkeleton key={index} />
            ))
          ) : carsList?.content?.length !== 0 ? (
            carsList?.content?.map((car, index) => (
              <Grid
                item
                xs={12}
                sm={6}
                md={4}
                lg={3}
                sx={{ display: "flex" }}
                key={index}
              >
                <CarCard
                  data={car}
                  isLoading={carsLoading}
                  // images={new Array(car?.images?.split(","))}
                />
              </Grid>
            ))
          ) : (
            <NoDataPlaceholder message="No cars available with the current search. Try a different one!!" />
          )}
        </Grid>
      </Container>
    </Layout>
  );
};

export default HomePage;
